/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_DocumentInputs */

const en_common_document = /** @type {(inputs: Common_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document`)
};

/**
* | output |
* | --- |
* | "Document" |
*
* @param {Common_DocumentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_document = /** @type {((inputs?: Common_DocumentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_DocumentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_document(inputs)
});